export enum ResponseCodeEnum {
  failure = 'failure',
  success = 'success',
}

// TODO: перенести обработку ошибок на agw методы https://jira.lenta.com/browse/B2B-6226
export enum B2BInfoUrlPathEnum {
  b2bInfo = '/pro/front/api/v1',
}

export enum B2BInfoMethod {
  legalEntityCreate = '/legalEntity/create',
  legalEntityAddressCreate = '/legalEntity/address/create',
  legalEntity = '/legalEntity',
  legalEntityEmailConfirm = '/legalEntity/email/confirm',
}

export enum RequestHeaderParams {
  APP_VERSION = 'App-Version',
  CLIENT = 'Client',
  CONTENT_TYPE = 'Content-Type',
  DEVICE_ID = 'Deviceid',
  SESSION_TOKEN = 'SessionToken',
  X_LENTA_TG_KEY = 'X-Lenta-Tg-Key',
  X_DELIVERY_MODE = 'X-Delivery-Mode',
  X_DEVICE_WEB_PLATFORM = 'X-Device-Web-Platform',
  X_DEVICE_ID = 'X-Device-Id',
  X_DOMAIN = 'X-Domain',
  X_RETAIL_BRAND = 'X-Retail-Brand',
  X_QUERY_HOST = 'X-Query-Host',
  X_ORGANIZATION_ID = 'X-Organization-Id',
  X_PASSPORT_ID = 'X-Passport-Id',
  ADD_MARKETING_PARTNER_KEY = 'MarketingPartnerKey',
  X_USER_SESSION_ID = 'X-User-Session-Id',
  X_STOREFRONT_LABEL = 'X-Storefront-Label',
  X_STOREFRONT_LABELS = 'X-Storefront-Labels',
  X_DEVICE_OS = 'X-Device-OS',
  ADID = 'Adid',
  ADVERTISING_ID = 'AdvertisingId',
}

export const domainRegexp: RegExp = /^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//;
